import gql from "graphql-tag";

export const DELETE_RESOURCES_ON_TRUCKING_DATAS = gql`
  mutation deleteResourcesOnTruckingDatas($where: [String]!) {
    deleteResourcesOnTruckingDatas(where: $where)
  }
`;